"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _questPermissionsByArea = _interopRequireDefault(require("../../helpers/questPermissionsByArea.js"));
var _admin = require("../../selectors/admin.js");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Fortress = window.cccisd.fortress;
var NoProjectsMessage = function NoProjectsMessage(_ref) {
  var isExported = _ref.isExported;
  if (isExported) {
    return /*#__PURE__*/_react["default"].createElement("h3", {
      className: _style["default"].info
    }, "No Data");
  }
  var projectLinks = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getProjectLinks)(state.assignment.admin);
  });
  var project = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getCurrentProject)(state.assignment.admin);
  });
  var hasDesignPermissions = Fortress.hasAnyAccess(_questPermissionsByArea["default"].design.permissions, project.groupId);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].info
  }, /*#__PURE__*/_react["default"].createElement("h3", null, "This project has no Quests."), hasDesignPermissions && /*#__PURE__*/_react["default"].createElement("p", null, "Create Quests from the \"", /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: projectLinks.design
  }, "Design"), "\" tab."));
};
var _default = exports["default"] = NoProjectsMessage;